<div class="only-read-metadata-data-div">
  <span class="text-content" [title]="value">{{value ? value: ''}}</span>
  <button mat-icon-button (click)="openDialog()" *ngIf="value && value.length > 19">
    <mat-icon>visibility</mat-icon>
  </button>
</div>
